import { createFileRoute, redirect } from '@tanstack/react-router';

const ROOT = '/management/risk-management';

export const Route = createFileRoute('/management/risk-management/(pages)')({
  // The nav entry points at the bare path, which holds no screen of its own —
  // it forwards to the tab the old page opened on.
  beforeLoad: ({ location }) => {
    if (location.pathname === ROOT || location.pathname === `${ROOT}/`) {
      throw redirect({ to: `${ROOT}/risk-gross` });
    }
  },
});
